import {Button} from '@/components';
import {TableSkeleton} from '@/components/Table/TableSkeleton';
import type {AfriexAdminTransaction} from '@/types';

import TransactionTable from './TransactionTable';

// Branch order is load-bearing: a failed request leaves the list at [], so the
// error arm must sit ahead of the table or a 500 reads as "no transactions".
const TransactionTableContent = ({
  error,
  isLoading,
  items,
  onRetry,
}: {
  error: unknown;
  isLoading: boolean;
  items: AfriexAdminTransaction[];
  onRetry: () => void;
}) => {
  if (isLoading) {
    return (
      <div data-cy="admin-transactions-loading">
        <TableSkeleton />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-500" data-cy="admin-transactions-error-state">
        Failed to load transactions.{' '}
        <Button
          variant="ghost"
          onClick={onRetry}
          data-cy="admin-transactions-error-retry"
        >
          Retry
        </Button>
      </div>
    );
  }

  return <TransactionTable items={items} />;
};

export default TransactionTableContent;
